/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_ToInputs */

const de__field_to = /** @type {(inputs: _Field_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bis`)
};

/**

* @param {_Field_ToInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_to = /** @type {((inputs?: _Field_ToInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_ToInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_to(inputs)
});